import script from "./FirmarDocumentoVidsigner.vue?vue&type=script&setup=true&lang=js"
export * from "./FirmarDocumentoVidsigner.vue?vue&type=script&setup=true&lang=js"

import "./FirmarDocumentoVidsigner.vue?vue&type=style&index=0&id=dc05b112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc05b112"]])

export default __exports__